import { inject, injectable } from "inversify";
import IConsentInfoService from "./IConsentInfoService";
import IConsentInfoResponseDto from "../dto/IConsentInfoResponseDto";
import ThirdPartyTypes from "../../di/ThirdPartyTypes";
import { AxiosInstance } from "axios";
import { GatewayServiceEndpoints } from "../../constants/apiRoutes";

@injectable()
export default class ConsentInfoService implements IConsentInfoService {
    @inject(ThirdPartyTypes.Axios)
    private apiClient!: AxiosInstance;

    public async getConsentInfo(url: string, accessToken: string): Promise<IConsentInfoResponseDto> {
        
        const response = await this.apiClient.get<IConsentInfoResponseDto>(
            GatewayServiceEndpoints.connectionDetails(url),
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ); 
        return {
            providerId: response.data.providerId,
            providerName: response.data.providerName,
            countryCode: response.data.countryCode,
            customerName: response.data.customerName,
            customerReference: response.data.customerReference,
            consentStatus: response.data.consentStatus,
            consentJourneyType: response.data.consentJourneyType,
            accounts: response.data.accounts,
            consentEndDate: response.data.consentEndDate ? new Date(response?.data?.consentEndDate) : response.data.consentEndDate,
            lastUpdatedDate: response.data.lastUpdatedDate ? new Date(response.data.lastUpdatedDate) : response.data.lastUpdatedDate,
            reconfirmByDate: response.data.reconfirmByDate ? new Date(response.data.reconfirmByDate) : response.data.reconfirmByDate,
        }
    }
}